import {
  INITIALIZE_WORKOUT_PAGE_DATA, UPDATE_GRAPH_MARKER, UPDATE_LAPS, FOCUS_ON_LAP,
} from '../../../constants/actionTypes';

export const initialState = {
  id: null,
  laps: null,
  heatmap: null,
  geoJSON: null,
  mapBounds: null,
  focusedLap: null,
  graphData: null,
  graphMarker: null,
  graphPointerValue: null,
  lapLength: 500,
  isUserLaps: false,
  hrZones: null,
  activityInfo: null,
  activityGroupInfo: null,
};

export default function workoutPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case (INITIALIZE_WORKOUT_PAGE_DATA):
      return {
        ...initialState,
        id: action.id,
        geoJSON: action.geoJSON,
        mapBounds: action.mapBounds,
        activityInfo: action.activityInfo,
        activityGroupInfo: action.activityGroupInfo,
        heatmap: action.heatmap,
        graphData: action.graphData,
        hrZones: action.hrZones,
        laps: action.laps,
      };
    case UPDATE_GRAPH_MARKER:
      return { ...state, graphMarker: action.graphMarker, graphPointerValue: action.graphPointerValue };
    case UPDATE_LAPS:
      return {
        ...state, laps: action.laps, lapLength: action.lapLength, isUserLaps: action.isUserLaps, focusedLap: null,
      };
    case FOCUS_ON_LAP:
      return { ...state, focusedLap: action.focusedLap };
    default:
      return state;
  }
}
